export const APP_VERSION = '1.27.0';

type AppReleaseNote = {
    version: string;
    date: string;
    notes: string[];
};

export const RELEASE_NOTES: AppReleaseNote[] = [
    {
        version: '1.27.0',
        date: '2026-08-12',
        notes: [],
    },
];
